var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.showIcon)?_c('v-icon',{class:_vm.classes,attrs:{"small":_vm.$useSmallIcons(),"color":_vm.color}},[_vm._v(_vm._s(_vm.iconToShow))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }